import React from 'react';
import { Steps } from '../../../../components';

export const UploadSteps = ({ step, validationError }) => {
    return (
        <Steps
            orientation="vertical"
            current={step}
            items={[
                {
                    title: validationError ? 'File Error' : 'Select File',
                    content: step === 0 ? 'Select RVTools zip file' : undefined,
                    status: validationError ? 'error' : undefined,
                },
                {
                    title: 'Extract CSV Files',
                },
                {
                    title: 'Review',
                    content: step === 2 ? 'Review your data before importing' : undefined,
                },
                {
                    title: 'Adding to Inventory',
                },
            ]}
        />
    );
};
